import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class DataPipelineService {
  async getDefaultPipeline(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/datapipeline/default`)).data;
  }

  async getDataPipelineList(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/dataPipeline/pipelinelist`)).data;
  }

  async getDataPipeline(Workspace_id, DataPipeline_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}`)).data;
  }

  async addNewDataPipeline(Workspace_id, data) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/datapipeline`, data)).data;
  }

  async saveDataPipeline(Workspace_id, DataPipeline_id, data) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}`, data)).data;
  }

  async getDataPipelineStatus(Workspace_id, DataPipeline_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/refresh`)).data;
  }

  async updateIsDefault(Workspace_id, DataPipeline_id, postData) {
    return (
      await fetchApi.post(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/update-is-default`, postData)
    ).data;
  }

  async runDataPipeline(Workspace_id, DataPipeline_id) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/run`)).data;
  }

  async deleteDataPipeline(Workspace_id, DataPipeline_id) {
    return (await fetchApi.delete(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}`)).data;
  }

  async makeClone(Workspace_id, DataPipeline_id) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/clone-pipeline`)).data;
  }

  async cloneJob(Workspace_id, DataPipeline_id, submitData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/clone-job`, submitData))
      .data;
  }

  async getPipelineHistory(Workspace_id, DataPipeline_id, startDate, endDate, { orderBy, order, UserTimezone }) {
    startDate = startDate ? `startdate=${startDate}&` : "";
    endDate = endDate ? `enddate=${endDate}&` : "";
    const paramQuery = `orderBy=${orderBy}&order=${order}&tz=${UserTimezone}`;
    return (
      await fetchApi.get(
        `/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/history?${startDate}${endDate}${paramQuery}`
      )
    ).data;
  }

  async getJobsHistory(
    Workspace_id,
    DataPipeline_id,
    Chain_id,
    startDate,
    endDate,
    { search, limit, page, orderBy, order }
  ) {
    startDate = startDate ? `startdate=${startDate}&` : "";
    endDate = endDate ? `enddate=${endDate}&` : "";
    let paramQuery = `limit=${limit}&page=${page}&orderBy=${orderBy}&order=${order}&search=${search}`;

    return (
      await fetchApi.get(
        `/workspace/${Workspace_id}/datapipeline/${DataPipeline_id}/history/${Chain_id}?${startDate}${endDate}${paramQuery}`
      )
    ).data;
  }
}
